interface ThirdPartyAuthParameters {
    token: string;
}

export default class ThirdPartyAuth {
    public token: string;

    public constructor(params: ThirdPartyAuthParameters) {
        this.token = params.token;
    }
}